import React from 'react';
import Footer from '../components/Footer';
import './Background.css';

const Background = () => {
  return (
    <div className="Background">
      <img
        className="Background_Images"
        src="images/main_background2.jpg"
        alt="444"
      />
      <div className="Background_Message">Hello World</div>

      <div className="artlist">
        <img className="art Images1" src="images/작품(1).jpg" alt="444" />
        <img className="art Images2" src="images/작품(2).jpg" alt="444" />
        <img className="art Images3" src="images/작품(3).jpg" alt="444" />
        <img className="art Images4" src="images/작품(4).jpg" alt="444" />
        <img className="art Images5" src="images/작품(5).jpg" alt="444" />
        <img className="art Images6" src="images/작품(6).jpg" alt="444" />
        <img className="art Images7" src="images/작품(7).jpg" alt="444" />
        <img className="art Images8" src="images/작품(8).jpg" alt="444" />
        <img className="art Images9" src="images/작품(9).jpg" alt="444" />
        <img className="art Images10" src="images/작품(10).jpg" alt="444" />
      </div>
      <Footer></Footer>
    </div>
  );
};

export default Background;
